import React from 'react'
import * as R from 'ramda'
import { formatPriceCents } from 'sidecar-utility-library'

import { Amount, Bullet, Link, Row } from './styles'

const Component = ({
  handlers: { expenseHandler, memberHandler, policyHandler } = {},
  link = {},
  memberApp,
  subTransactions = [],
  redactLinkData = false,
  uuids = {},
}) => (
  <React.Fragment>
    {R.has('multiMember')(link) &&
      link.multiMember.map((st, index) => (
        <Row key={index}>
          {st.member && memberApp ? (
            <span data-heap-redact-text={redactLinkData}>{st.member}</span>
          ) : (
            <Link
              data-heap-redact-text={redactLinkData}
              onClick={
                memberHandler
                  ? subTransactions.length > 0
                    ? memberHandler(subTransactions[0].memberUuid)
                    : memberHandler(uuids.memberUuid)
                  : () => {}
              }
            >
              {st.member}
            </Link>
          )}
          {/* 
            idk why this bullet needed css to always have the space
            while the one for the non multi member didn't... css?!?
          */}
          {st.policy && <Bullet> · </Bullet>}
          {st.policy && (
            <Link onClick={policyHandler(uuids.policyUuid)}>{st.policy}</Link>
          )}
          {st.amount && <Amount>{formatPriceCents(st.amount)}</Amount>}
        </Row>
      ))}

    {!R.has('multiMember')(link) && (
      <React.Fragment>
        {link.member && memberApp ? (
          <span data-heap-redact-text={redactLinkData}>{link.member}</span>
        ) : (
          <Link
            data-heap-redact-text={redactLinkData}
            onClick={
              memberHandler
                ? subTransactions.length > 0
                  ? memberHandler(subTransactions[0].memberUuid)
                  : memberHandler(uuids.memberUuid)
                : () => {}
            }
          >
            {link.member}
          </Link>
        )}
        {(link.policy || link.expense) && <span> · </span>}
        {link.policy && (
          <Link
            onClick={
              uuids.masterPolicyUuid
                ? policyHandler(uuids.masterPolicyUuid)
                : policyHandler(uuids.policyUuid)
            }
          >
            {link.policy}
          </Link>
        )}
        {link.expense && (
          <Link onClick={expenseHandler(uuids.expenseUuid)}>
            {link.expense}
          </Link>
        )}
      </React.Fragment>
    )}
  </React.Fragment>
)

Component.displayName = 'InfoLink'

export default Component
